import { Injectable } from '@angular/core';
import { CanonicalUrlOptions, PageLinkService, PageMetaConfig, WindowRef } from '@spartacus/core';

@Injectable({ providedIn: 'root' })
export class CustomPageLinkService extends PageLinkService {
  constructor(
    protected pageMetaConfig: PageMetaConfig,
    protected winRef: WindowRef
  ) {
    super(pageMetaConfig, winRef);
  }

  protected buildCanonicalUrl(
    url: string,
    options: CanonicalUrlOptions
  ): string {
    const newUrl = this.removeHashPart(url);
    return super.buildCanonicalUrl(newUrl, options);
  }

  private removeHashPart(url: string): string {
    const hashIndex = url.indexOf('#');
    return hashIndex !== -1 ? url.substring(0, hashIndex) : url;
  }
}
